module.exports = __webpack_public_path__ + "static/media/ico-access.2ebbd32a.svg";